// All of the site's copy lives here, so it can be edited without touching layout code.

export const site = {
  name: 'Ian Bunn',
  studio: 'Ian Bunn Studio',
  email: 'ian@ianbunn.studio',
  location: 'Austin, TX',
  timeZone: 'America/Chicago',
  since: 2015,
  resume: '/documents/ian-bunn-sr-software-engineer-resume.pdf',
  motto: 'To higher standards & purpose.',
};

export const socials = [
  { label: 'LinkedIn', href: 'https://linkedin.com/in/ianbunn' },
  { label: 'GitHub', href: 'https://github.com/ianbunn' },
  { label: 'Instagram', href: 'https://instagram.com/h1rbb' },
];

// Words cycled in the hero: "I make ___"
export const makes = ['software', 'apps', 'films', 'scripts', 'comics', 'graphic novels', 'poems', 'community', 'good trouble'];

export const fields = [
  'Software Engineering',
  'Cannabis',
  'Technology',
  'Arts',
  'Film',
  'Scripts',
  'Comics',
  'Graphic Novels',
  'Poetry',
  'Activism',
  'Volunteerism',
  'Family',
];

// Wrap words in *asterisks* to set them in serif italic.
export const manifesto =
  "I'm Ian. A senior software engineer, founder, and the person behind this studio: a collective of projects that wander across *code,* *cannabis,* *film,* *scripts,* *comics,* *graphic novels,* *poetry,* and the communities I show up for. Some ship to app stores. Some get read out loud. All of them start with the same question. How do we make things *a little better,* for more people?";

export const aside = ['Proud husband.', 'Dog dad.', 'Austin, Texas.'];

export const now = [
  {
    label: 'Day job',
    name: 'EPIC',
    role: 'Sr. Software Engineer',
    description:
      'Building the treasury: the payment system that moves millions of dollars a day between dealerships and lenders, from API to interface to infrastructure.',
    href: 'https://www.withepic.com/',
    cta: 'withepic.com',
  },
  {
    label: 'Side project',
    name: 'greent',
    role: 'Founder',
    description:
      'The cannabis journal for the deeply relaxed. Scan a jar, rate the experience, and remember every strain. A platform for growers and consumers, made by cannabis people.',
    href: 'https://greent.club/',
    cta: 'greent.club',
  },
];

export type Project = {
  name: string;
  field: string;
  note: string;
  year: string;
  href?: string;
};

export const collective: Project[] = [
  {
    name: 'EPIC',
    field: 'Software · Fintech',
    note: 'Treasury & payments, millions of dollars a day.',
    year: 'Now',
    href: 'https://www.withepic.com/',
  },
  {
    name: 'greent',
    field: 'Cannabis · Technology',
    note: 'A cannabis journal, without the journaling.',
    year: 'Live',
    href: 'https://greent.club/',
  },
  {
    name: 'Open Source',
    field: 'Code · Tools',
    note: 'Experiments, utilities and things worth sharing.',
    year: 'Ongoing',
    href: 'https://github.com/ianbunn',
  },
  {
    name: 'Scripts & Comics',
    field: 'Arts · Writing',
    note: 'Scripts, comic books & graphic novels, one panel at a time.',
    year: 'In progress',
  },
  {
    name: 'Poetry',
    field: 'Arts · Language',
    note: 'Words for the things code cannot say.',
    year: 'Always',
  },
  {
    name: 'Film',
    field: 'Arts · Story',
    note: 'Stories told in frames, slowly and on purpose.',
    year: 'In progress',
  },
  {
    name: 'Activism',
    field: 'Community · Justice',
    note: 'Showing up, speaking up, making good trouble.',
    year: 'Always',
  },
  {
    name: 'Volunteerism',
    field: 'Community · Service',
    note: 'Time and skills, given back to the neighborhood.',
    year: 'Always',
  },
  {
    name: 'Home',
    field: 'Husband · Dog dad',
    note: 'The best project. Proudly, the most important one.',
    year: 'Forever',
  },
];

export const record = [
  { years: '2025–Now', company: 'EPIC', role: 'Sr. Software Engineer' },
  { years: '2024–2026', company: 'greent', role: 'Technical Founder & CSO' },
  { years: '2024–2025', company: 'Deal.ai', role: 'Sr. Software Engineer' },
  { years: '2020–2024', company: 'WIN Reality', role: 'Software Engineer' },
  { years: '2020', company: 'BuildGroup', role: 'Front-end Engineer' },
  { years: '2018–2020', company: 'Trusted Capital Group', role: 'Software Developer' },
  { years: '2015–2018', company: 'Trusted Capital Group', role: 'IT Technical Project Manager' },
];

export const education = [
  { years: '2019', school: 'The University of Texas at Austin', detail: 'Full-stack Development' },
  { years: '2017', school: 'freeCodeCamp', detail: 'Full-stack Web Development' },
  { years: '2008', school: 'Our Lady of the Lake University', detail: 'BBA, Finance' },
];

export const toolbox = [
  'Go',
  'TypeScript',
  'NestJS',
  'React',
  'React Native',
  'Node.js',
  'Python',
  'PostgreSQL',
  'MongoDB',
  'AWS',
  'Terraform',
  'Terragrunt',
  'Docker',
  'Expo',
];
